import { T } from '@tribeplatform/react-components/i18n'
import { useSlate } from '@tribeplatform/react-slate-kit/hooks'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { EditorSlateExtraContext } from '../types.js'
import { SlateTreeItemInfo } from './types.js'

interface Props {
  treeItem: SlateTreeItemInfo
  isExpanded: boolean
  indentation: number
}

export const ColumnChildrenPlaceholder = ({
  isExpanded,
  treeItem,
  indentation,
}: Props) => {
  const {
    data: { children, id: columnBlockId },
  } = treeItem
  const hasChildren = children.length > 0
  const {
    extraContext: {
      slate: { openAddBlock },
    },
  } = useSlate<EditorSlateExtraContext>()

  if (hasChildren || !isExpanded) {
    return null
  }

  return (
    <div
      className="hover:bg-surface-hovered hover:text-content"
      onClick={e => {
        e.stopPropagation()
        openAddBlock(columnBlockId)
      }}
    >
      <div className="py-2 px-2 cursor-pointer">
        <div
          className="flex items-center gap-1"
          style={{
            paddingInlineStart: `${indentation}px`,
          }}
        >
          <div className="overflow-hidden pl-6">
            <div className="flex items-center gap-1 min-w-0">
              <span className="text-interactive">
                <SvgIcon
                  inline
                  name="plus"
                  size="md"
                  color="text-interactive"
                />
              </span>
              <span className="text-sm text-interactive truncate">
                <T id="BlockActions.AddBlock" defaultMessage="Add block" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
